import { useContractorAuth } from "../context/ContractorAuthContext";
import { useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { Button } from "./ui/button";
import { LogOut } from "lucide-react";

export function ContractorShell({ children }) {
  const { data, logout } = useContractorAuth();
  const navigate = useNavigate();
  const profile = data?.profile;
  return (
    <div className="min-h-screen bg-secondary/30">
      <div className="overflow-hidden bg-red-600 py-1.5" data-testid="testing-banner">
        <div className="marquee text-sm font-semibold text-white">
          This system is currently in TESTING — please report any problems to kcockram@gfm-uk.com&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;This system is currently in TESTING — please report any problems to kcockram@gfm-uk.com&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;
        </div>
      </div>
      <header className="sticky top-0 z-30 border-b border-border bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-3">
          <button onClick={() => navigate("/contractor")} data-testid="contractor-home"><Logo showName={false} /></button>
          <div className="flex items-center gap-3">
            <div className="hidden text-right sm:block">
              <div className="text-sm font-semibold leading-tight">{profile?.name}</div>
              <div className="text-xs text-muted-foreground">{profile?.company}</div>
            </div>
            <Button variant="outline" size="sm" onClick={logout} data-testid="contractor-logout">
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-6 py-8">{children}</main>
    </div>
  );
}
